import { render, staticRenderFns } from "./Beneficiaires.vue?vue&type=template&id=1b1107bd"
import script from "./Beneficiaires.vue?vue&type=script&lang=js"
export * from "./Beneficiaires.vue?vue&type=script&lang=js"
import style0 from "./Beneficiaires.vue?vue&type=style&index=0&id=1b1107bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports